<template>
  <div class="ima-login container">

<div class="ima-login__logo-container">
    <svg class="ima-login__logo" width="50" height="50" viewBox="0 0 350 350" version="1.1"
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">

  <circle stroke="#002d59" stroke-width="7" fill="none" cx="175" cy="175" r="170"></circle>
	<path fill-rule="evenodd" fill="#002d59" d="M106.2,121.8h31.4l29.7,75.9l30.6-75.9h30v3.4h-13.2v90.7h3.8h9.4h2l32.2-95.8h2.7
		l31.5,95.8h12.6v3.4H265v-3.4h14.2l-9.3-30.6h-25.4l-10,30.6h14.3v3.4h-21h-9.4h-33.8v-3.4h15.3v-88.4h-0.3l-37.4,93.5h-2
		l-36.4-93.5h-0.3v88.4h14.7v3.4h-32.1v-3.4h13.2v-90.7h-13.2V121.8z M69.8,215.9v-90.7H56.9v-3.4h41.2v3.4H85.3v90.7h12.8v3.4H56.9
		v-3.4H69.8z M268.7,181.1l-10.8-34.9h-0.3l-11.7,34.9H268.7z"></path>

    </svg>
    <span class="ima-login__logo-text">
    Messeschilder
    </span>


</div>

    <form v-on:submit="onSubmit($event)">

      <div class="field">
        <label class="label">E-Mail</label>
        <input type="email" class="input" placeholder="E-Mail" required v-model="email">
      </div>

      <div class="field">
        <label class="label">Passwort</label>
        <input type="password" class="input" placeholder="Passwort" required v-model="password">
      </div>

      <div class="field">
        <p class="control">
          <button type="submit" class="button is-primary ima-login__button" :class="{'is-loading' : user.isLoading}">Login</button>
        </p>
      </div>
    </form>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router'
import routes from '@/mixins/routes'
import { login } from '@/store/modules/user'

export default {
  name: 'ima-login',
  mixins: [routes],
  data () {
    return {
      email: null,
      password: null
    }
  },
  computed: {
    ...mapState(['user', 'errors'])
  },
  methods: {
    ...mapActions([login]),
    onSubmit ($event) {
      $event.preventDefault()
      this.login({ email: this.email, password: this.password })
        .then(() => {
          router.push({ name: this.routes.DASHBOARD })
        })
        .catch(() => {
          router.push({ name: this.routes.LOGIN })
        })
    }
  }
}
</script>


<style scoped lang="scss">
@import '../scss/settings';
.ima-login {
  background-color: #fff;
  border-radius: 0.2rem;
  box-shadow: 0 0.2rem 1rem 0px rgba(0, 0, 0, 0.15);
  left: 50%;
  max-width: 30rem;
  padding: 1.8rem;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);

  &__brand-logo {
    text-align: right;

    svg {
      path {
        fill: #002d59;
      }
    }
  }

  &__logo-separator {
    flex-grow: 1;
    text-align: center;
    span {
      border-left: 1px solid $highlight;
      display: inline-block;
      height: 3rem;
    }
  }

  &__logo {
    &-container {
      display: flex;
      align-items: center;
      margin: 0.5rem 0 2rem 0;
    }

    &-text {
      color: $primary;
      font-family: Georgia, 'Times New Roman', Times, serif;
      font-size: 1.2rem;
      margin-left: 0.75rem;
    }
  }

  &__button {
    background-color: $highlight;
    font-size: 1.1rem;
    margin-top: 1rem;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue